module.exports = __webpack_public_path__ + "static/media/a31.b8df8513.pdf";